import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { croppedImg } from 'utils'

import { clearGiftCard as clearGiftCardAction } from 'actions/gift-card'

class GiftCardBox extends React.Component {
  constructor(props) {
    super(props)

    this.resetBeforeRouteChange = this.resetBeforeRouteChange.bind(this)
  }

  resetBeforeRouteChange() {
    const { clearGiftCard } = this.props

    clearGiftCard()

    return false
  }

  render() {
    const { giftCard, locale, cellarId, giftCardId } = this.props
    const { language, amounts, mainImage, title, description, currency } = giftCard

    return (
      <div
        className="event-container"
      >
        <Link
          className="event-box"
          to={
            `/${locale}/${cellarId}/gift-cards/${giftCardId}` +
            `?lang=${language}`
          }
          onClick={this.resetBeforeRouteChange}
        >
          <div className="event-box__content">
            <div className="event-box__image">
              <div className="event-box__image__labels">
                <div className="event-box__image__label">
                  <i className="icon--gift-box icon--huge" />
                  <FormattedMessage id="app.gift-card.label" />
                </div>
              </div>
              <img
                src={croppedImg(mainImage, 730, 360)}
              />
            </div>
            <h3 className="event-box__title">
              {title}
            </h3>
            <div
              className="event-box__description"
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            >
            </div>
            {/* START: just to keep space */}
            <div className="event-box__info" style={{ visibility: 'hidden' }}>
              <p className="event-box__row">
                <span className="event-box__row__label">
                  <FormattedMessage id="app.cellar.event.place" />
                </span>
              </p>
              <p className="event__row">
                <span className="event-box__row__label">
                  <FormattedMessage id="app.cellar.event.duration" />
                </span>
              </p>
            </div>
            {/* END: just to keep space */}
            <div className="event-box__footer">
              <div className="or">
                <div className="or__item">
                  <FormattedHTMLMessage
                    id={'app.gift-card.price_html'}
                    values={{ amount: Math.min(...amounts), currency }}
                  />
                </div>
                <div className="or__item">
                  <span className="button--small button--primary">
                    <FormattedMessage id="app.gift-card.cta" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    )
  }
}

GiftCardBox.propTypes = {
  giftCard: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  cellarId: PropTypes.string.isRequired,
  giftCardId: PropTypes.string.isRequired,
  clearGiftCard: PropTypes.func.isRequired,
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    clearGiftCard: clearGiftCardAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftCardBox)
